import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { visuallyHidden } from '@mui/utils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React
// ,{ useState, useEffect }
    from 'react';

import { useTaskContext } from '../../Contexts/suiviMission/TaskContext';
import NameCustom from './NameCustom';
import Priority from './Priority';
import Status from './Status';

// function createData(id, name, status, priority, responsable) {
//   return {
//     id,
//     name,
//     status,
//     priority,
//     responsable,
//   };
// }

// const tasks = [
//   createData(
//     "1",
//     "Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "2",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "Medium",
//     "Meriem"
//   ),
//   createData(
//     "3",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "4",
//     " Task de test Task de test Task de test Task de test ",
//     "Termine",
//     "Low",
//     "Khaoula"
//   ),
//   createData(
//     "5",
//     " Task de test Task de test Task de test Task de test ",
//     "A faire",
//     "High",
//     "Reda"
//   ),
//   createData(
//     "6",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "7",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "Low",
//     "Aida"
//   ),
//   createData(
//     "8",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "9",
//     " Task de test Task de test Task de test Task de test ",
//     "A faire",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "10",
//     " Task de test Task de test Task de test Task de test ",
//     "Termine",
//     "Medium",
//     "Meriem"
//   ),
//   createData(
//     "11",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "12",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "High",
//     "Meriem"
//   ),
//   createData(
//     "13",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "Low",
//     "Meriem"
//   ),
//   createData(
//     "14",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "Medium",
//     "Meriem"
//   ),
//   createData(
//     "15",
//     " Task de test Task de test Task de test Task de test ",
//     "En cours",
//     "Medium",
//     "Meriem"
//   ),
// ];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    // {
    //   id: "id",
    //   numeric: true,
    //   disablePadding: true,
    //   label: "Id",
    // },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Nom',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'Statut',
    },
    {
        id: 'priority',
        numeric: false,
        disablePadding: false,
        label: 'Priorité',
    },
    {
        id: 'responsable',
        numeric: false,
        disablePadding: false,
        label: 'Responsable',
    },
];

function EnhancedTableHead(props) {
    const {
        onSelectAllClick,
        order,
        orderBy,
        numSelected,
        rowCount,
        onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'left' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box
                                    component="span"
                                    sx={visuallyHidden}
                                >
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { numSelected } = props;

    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(
                            theme.palette.primary.main,
                            theme.palette.action.activatedOpacity
                        ),
                }),
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {numSelected} sélectionnés
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
					Tâches
                </Typography>
            )}

            {numSelected > 0 ? (
                <Tooltip title="Delete">
                    <IconButton>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Tooltip title="Filter list">
                    <IconButton>
                        <FilterListIcon />
                    </IconButton>
                </Tooltip>
            )}
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function TasksList() {
    // const [tasks, setTasks] = useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(7);
    const { tasks
        // , setTasks
    } = useTaskContext();
    // useEffect(() => {
    //   fetchTasks(setTasks);
    // }, [])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = tasks.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty tasks.
    const emptyRows =
		page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tasks.length) : 0;

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                <EnhancedTableToolbar numSelected={selected.length} />
                <TableContainer>
                    <Table
                        sx={{ width: '100%', height: '100%' }}
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={tasks.length}
                        />
                        <TableBody>
                            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 tasks.slice().sort(getComparator(order, orderBy)) */}
                            {stableSort(tasks, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row._id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) => handleClick(event, row._id)}
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row._id}
                                            selected={isItemSelected}
                                            style={{
                                                backgroundColor:
													moment(row.dateFin).valueOf() < moment().valueOf()
													    ? '#E9ECF1'
													    : 'inherit',
                                            }}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    color="primary"
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                    }}
                                                />
                                            </TableCell>
                                            {/* <TableCell
                      style={{ width: 10 }}
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="   ne"
                        align="left"
                      >
                        {row._id}
                      </TableCell> */}
                                            <TableCell align="left">
                                                {row.title}
                                                {moment(row.dateFin).valueOf() < moment().valueOf() ? (
                                                    <span
                                                        style={{
                                                            padding: '5px',
                                                            backgroundColor: '#F50000',
                                                            width: 'fit-content',
                                                            borderRadius: '3px',
                                                            marginLeft: '33px',
                                                            color: '#FFFFFF',
                                                        }}
                                                    >
														En retard
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </TableCell>
                                            <TableCell
                                                style={{ width: 130 }}
                                                align="left"
                                            >
                                                <Status status={row.status} />
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                style={{ width: 180 }}
                                            >
                                                <Priority priority={row.priority} />
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                style={{ width: 50 }}
                                            >
                                                <NameCustom
                                                    name={
                                                        row.expertId.length !== 0
                                                            ? row.expertId[0]?.persoData?.nom + row.expertId[0]?.persoData?.prenom
                                                            : 'unassigned'
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: 52 * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={tasks.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}
